module.exports = __webpack_public_path__ + "static/media/angular.9c0ac812.svg";